// constants
import { NotifyActionTypes } from './constants';
import { NotifySettings as NotifySettingsDataType } from 'src/types/notify';

export type NotifyActionType = {
    type:
        | NotifyActionTypes.API_RESPONSE_SUCCESS
        | NotifyActionTypes.API_RESPONSE_ERROR
        | NotifyActionTypes.GET_NOTIFYS
        | NotifyActionTypes.ADD_NOTIFY
        | NotifyActionTypes.EDIT_NOTIFY
        | NotifyActionTypes.GET_NOTIFY
        | NotifyActionTypes.RESET
        | NotifyActionTypes.RESET_SUCCESS
        | NotifyActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const notifyApiResponseSuccess = (
    actionType: string,
    data: NotifySettingsDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): NotifyActionType => ({
    type: NotifyActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const notifyApiResponseError = (
    actionType: string,
    data: NotifySettingsDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): NotifyActionType => ({
    type: NotifyActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addNotify = (params: any): NotifyActionType => ({
    type: NotifyActionTypes.ADD_NOTIFY,
    payload: params,
});

export const editNotify = (params: any): NotifyActionType => ({
    type: NotifyActionTypes.EDIT_NOTIFY,
    payload: params,
});

export const getNotify = (params: any): NotifyActionType => ({
    type: NotifyActionTypes.GET_NOTIFY,
    payload: params,
});

export const getNotifys = (params: any): NotifyActionType => ({
    type: NotifyActionTypes.GET_NOTIFYS,
    payload: params,
});

export const resetNotify = (): NotifyActionType => ({
    type: NotifyActionTypes.RESET,
    payload: {},
});

export const resetNotifySuccess = (): NotifyActionType => ({
    type: NotifyActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetNotifyError = (): NotifyActionType => ({
    type: NotifyActionTypes.RESET_ERROR,
    payload: {},
});
